
import { Vue, Component } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import InventoryModule from "@/store/modules/barcodeSystem/inventory";
import notifications from "@/lib/notifications";
import { InventoryItemListFilters } from "@/models/api/barcodeSystem/inventory/inventoryItems";
import BarcodeSystemModule from "@/store/modules/barcodeSystem";
import Papa from "papaparse";

const inventoryModuleState = getModule(InventoryModule);
const barcodeSystemModuleState = getModule(BarcodeSystemModule);

@Component
export default class InventoryItemFilters extends Vue {
  localFilters: InventoryItemListFilters = null;

  get filters() {
    return inventoryModuleState.itemFilters;
  }

  created() {
    this.localFilters = JSON.parse(JSON.stringify(this.filters));
  }

  async submit() {
    inventoryModuleState.setItemFilters(JSON.parse(JSON.stringify(this.localFilters)));
    inventoryModuleState.setLoading(true);
    try {
      await inventoryModuleState.getInventoryItems({
        pageNumber: 1,
        pageSize: inventoryModuleState.itemPageData.pageSize
      });     
    } catch (ex) {
      notifications.error("Loading Inventory Items", "Failed to load inventory items", ex);
    }

    inventoryModuleState.setLoading(false);
  }
  
  async exportInventoryItems() {
    inventoryModuleState.setLoading(true);
    try {    
      var csvData = [];
      var i = [];
      inventoryModuleState.itemFields.forEach(function (field) {
        if(field.label !== "") {
          i.push(field.label);
        }
      });
      csvData.push(i);
      if(inventoryModuleState.itemPageData.totalItems > inventoryModuleState.itemData.length){
        if(inventoryModuleState.itemPageData.totalItems < 5000) {
          await inventoryModuleState.getInventoryItemsExport({
            pageNumber: 1,
            pageSize: inventoryModuleState.itemPageData.totalItems
          });
        } else {
          await inventoryModuleState.getInventoryItemsExport({
            pageNumber: 1,
            pageSize: 5000
          });
        }
      }
      inventoryModuleState.itemData.forEach(function (item) {
        var i = [];
        inventoryModuleState.itemFields.forEach(function (field) {
          if(field.label !== "") { 
            if(field.label === "Company") {
              i.push(item.company.companyName);
            } else {
              i.push(item[field.key]);
            }
          }
        });
        csvData.push(i);
      });  
      let blob = new Blob([Papa.unparse(csvData)], {
        type: "text/csv;charset=utf-8;"
      });

      let link = document.createElement("a");

      let url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute("download", "InventoryItems.csv");
      link.style.visibility = "hidden";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

    } catch (ex) {
      console.log(ex);
      notifications.error("Downloading Inventory Items", "Failed to export inventory items", ex);
    }

    inventoryModuleState.setLoading(false);
  }

  get currentFacilityCode(): string {
    return barcodeSystemModuleState.currentFacilityCode;
  }

  get loading(): boolean {
    return inventoryModuleState.loading;
  }

  getBooleanOptions() {
    return [
      { label: "", value: null },
      { label: "Yes", value: true },
      { label: "No", value: false }
    ];
  }
}
